import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { UserPlus, Shield, User, Mail, MoreVertical, Trash2 } from 'lucide-react';

const UserList = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // For now, we'll just show the current admin user or fetch if the endpoint exists
        const fetchUsers = async () => {
            try {
                // If you have implemented GET /api/auth/users, uncomment below
                // const res = await axios.get('http://localhost:5000/api/auth/users');
                // setUsers(res.data);
                
                // Fallback for now: show a static list or just the logged in user info
                setUsers([
                    { _id: '1', name: 'VSK Admin', username: 'admin', role: 'admin', createdAt: new Date() }
                ]);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-dark-green">System Users</h3>
                <button className="flex items-center space-x-2 px-6 py-3 bg-gold-primary text-white rounded-xl font-bold hover:bg-gold-primary/90 transition-all shadow-lg">
                    <UserPlus size={18} />
                    <span>Add New User</span>
                </button>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-gray-50 border-b border-gray-100">
                            <tr>
                                <th className="px-8 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider">User Info</th>
                                <th className="px-8 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider">Username</th>
                                <th className="px-8 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider">Role</th>
                                <th className="px-8 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider">Created At</th>
                                <th className="px-8 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider"></th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="px-8 py-10 text-center text-gray-500">
                                        Loading users...
                                    </td>
                                </tr>
                            ) : (
                                users.map((user) => (
                                    <tr key={user._id} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-8 py-5">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 bg-dark-green/5 rounded-full flex items-center justify-center text-dark-green font-bold text-lg">
                                                    {user.name.charAt(0)}
                                                </div>
                                                <span className="font-bold text-dark-green">{user.name}</span>
                                            </div>
                                        </td>
                                        <td className="px-8 py-5">
                                            <span className="text-gray-600 font-medium">{user.username}</span>
                                        </td>
                                        <td className="px-8 py-5">
                                            <span className={`inline-flex items-center space-x-1 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider
                                                ${user.role === 'admin' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}
                                            `}>
                                                {user.role === 'admin' ? <Shield size={10} /> : <User size={10} />}
                                                <span>{user.role}</span>
                                            </span>
                                        </td>
                                        <td className="px-8 py-5">
                                            <span className="text-sm text-gray-500">{formatDate(user.createdAt)}</span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex justify-end space-x-2">
                                                <button className="text-gray-400 hover:text-red-600 transition-colors p-1">
                                                    <Trash2 size={18} />
                                                </button>
                                                <button className="text-gray-400 hover:text-dark-green transition-colors p-1">
                                                    <MoreVertical size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserList;
